export default __webpack_public_path__ + "static/media/mobile-bazar-thumb.d1c90818.png";